// components
import ContentLayout from "@/layouts/ContentLayout";
import TextBlock from "@/components/blocks/TextBlock";
import TitleBanner from "@/components/banners/TitleBanner";

// assets
import banner from "@/assets/images/about-us/meet-our-team/banner.png";
import michael from "@/assets/images/about-us/meet-our-team/michael.png";
import thomson from "@/assets/images/about-us/meet-our-team/thomson.png";
import max from "@/assets/images/about-us/meet-our-team/max.jpg";
import john from "@/assets/images/about-us/meet-our-team/john.jpg";
import kenneth from "@/assets/images/about-us/meet-our-team/kenneth.jpg";

// i18n
import { useTranslation } from "react-i18next";

const MeetOurTeam = () => {
  const { t } = useTranslation();

  const data = [
    {
      img: michael,
      name: "michael_wong",
      position: "chief_executive_officer",
      description: ["michael_wong_description1", "michael_wong_description2", "michael_wong_description3"],
    },
    {
      img: thomson,
      name: "thomson_cheng",
      position: "chief_operation_officer",
      description: ["thomson_cheng_description1", "thomson_cheng_description2"],
    },
    {
      img: max,
      name: "max_kaufhold",
      position: "north_and_south_america_regional_advisor",
      description: ["max_kaufhold_description1", "max_kaufhold_description2"],
    },
    {
      img: john,
      name: "john_yue",
      position: "business_and_trading_advisor",
      description: ["john_yue_description1", "john_yue_description2"],
    },
    {
      img: kenneth,
      name: "kenneth_lam",
      position: "it_director",
      description: ["kenneth_lam_description1", "kenneth_lam_description2"],
    },
  ];

  return (
    <div className="w-full">
      <TitleBanner bannerImg={banner} title={t("about_us.meet_our_team")} />
      <ContentLayout>
        <div className="flex flex-col gap-8 md:gap-[60px]">
          {data.map((item, index) => (
            <section className="mt-4 flex w-full flex-col gap-6 md:mt-6 md:flex-row md:gap-12" key={index}>
              <figure className="max-h-[300px] w-full overflow-hidden md:max-h-[400px] md:w-1/2">
                <img src={item.img} alt={item.name} className="h-full w-full object-cover" />
              </figure>
              <section className="w-full md:w-1/2">
                <p className="text-3xl font-bold leading-tight text-primary md:text-5xl md:leading-[60px]">
                  {t(`about_us.${item.name}`)}
                </p>
                <div className="w-full">
                  <p className="mt-2 text-xl font-thin leading-normal text-primary md:mt-0 md:text-3xl md:leading-[60px]">
                    {t(`about_us.${item.position}`)}
                  </p>
                  {item.description.map((description, index) => (
                    <p
                      className="mt-4 w-full text-sm font-normal leading-7 text-[#474747] md:mt-7 md:leading-9"
                      key={index}
                    >
                      {t(`about_us.${description}`)}
                    </p>
                  ))}
                </div>
              </section>
            </section>
          ))}
        </div>
      </ContentLayout>
    </div>
  );
};

export default MeetOurTeam;
